import { Label } from '@radix-ui/react-label'
import { forwardRef, InputHTMLAttributes } from 'react'

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  error?: string
  isError?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ id, label, isError, error, className, ...props }, ref) => (
    <div className="flex flex-col gap-2">
      {label && (
        <Label className="text-[14px] font-semibold" htmlFor={id}>
          {label}
        </Label>
      )}

      <input
        ref={ref}
        id={id}
        {...props}
        className={`${className ?? ''} bg-white border border-borderGray w-full text-base rounded-md shadow-soft py-3 px-4`}
      />

      {isError && <div className="text-error-default mt-1 text-sm">{error}</div>}
    </div>
  ),
)

Input.displayName = 'Input'
